var path = '/var/www/mmscny-website/src/app/components/about-us-advisory-committee/about-us-advisory-committee.html';
var html = "<feature-description-page-template details=$ctrl.details> </feature-description-page-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/about-us-advisory-committee/about-us-advisory-committee.html
// module id = 672
// module chunks = 0